module.exports = __webpack_public_path__ + "static/media/news4.8ca15a3f.jpg";